import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";

interface HeaderBackButtonProps {
  onClick?: () => void;
}

export const HeaderBackButton = ({ onClick }: HeaderBackButtonProps) => {
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      history.goBack();
    }
  };

  return (
    <TippyV2 content={t("help_widget.tooltip.back")}>
      <button
        type="button"
        onClick={handleClick}
        className="hover:bg-secondary flex h-6 w-6 items-center rounded-full p-1"
      >
        <Icon type="16-arrow-left" useWithFillCurrentColor size={16} />
      </button>
    </TippyV2>
  );
};
